/** Remove the element at `fromIndex`, then insert it at `toIndex` in the now-shorter array. */
export const moveItem = <T>(
  items: T[],
  fromIndex: number,
  toIndex: number,
): T[] => {
  const next = [...items];
  const [moved] = next.splice(fromIndex, 1);
  next.splice(toIndex, 0, moved);
  return next;
};
